import {Action} from '@ngrx/store';
import {QuoteWrapper} from '../../models/quote/quote-wrapper';
import {type} from '../store.util';
import {QuoteService} from "../../models/quote/quote-service";
import {PricingItem} from "../../models/quote/pricing-item/pricing-item";
import { EnumQuoteServiceSalesType } from '../../models/enum/enum-quote-service-sales-type';
import {ServiceLine} from '../../models/quote/service-line';
import {QuoteState} from './quote.reducers';

export const QuoteActionTypes = {
    HYDRATE_QUOTE_STORE: type('[quote-store] hydrate'),
    HYDRATE_QUOTE_STORE_SUCCESS: type('[quote-store] hydrate success'),
    CORRIDOR_UPDATE: type('[corridor] Corridor update'),

    QUOTE_UPDATE_ACTION: type('[quote] update'),
    QUOTE_UPDATE_SUCCESS: type('[quote] update success'),

    QUOTE_LINE_UPDATE_ACTION: type('[serviceLine] update'),
    QUOTE_LINE_UPDATE_SUCCESS: type('[ServiceLine] Update success'),
    QUOTE_SERVICE_UPDATE_ACTION: type('[quoteService] update'),
    QUOTE_SERVICE_APPLIED_PRICE_UPDATE_ACTION: type('[quoteService] applied price update'),
    QUOTE_SERVICE_UPDATE_SUCCESS: type('[quoteService] update success'),
    PRICING_ITEM_UPDATE_ACTION: type('[pricingItem] update'),
    PRICING_ITEM_DELETE_ACTION: type('[pricingItem] delete'),
    PRICING_ITEM_VALIDATE_ACTION: type('[pricingItem] validate'),
    CREATE_REFERENTIAL_ACTION: type('[referential] create'),

    CREATE_REFERENTIAL_SERVICES_ACTION: type('[referential_services] create'),

    RESET_WRAPPER_ACTION: type('[wrapper] reset'),


};

export class QuoteServiceUpdateAction implements Action {
    public type: string = QuoteActionTypes.QUOTE_SERVICE_UPDATE_ACTION;

    constructor(public payload?: { quoteService: QuoteService, executeEffects: boolean }) {
    }
}

export class QuoteUpdateAction implements Action {
    public type: string = QuoteActionTypes.QUOTE_UPDATE_ACTION;

    constructor(public payload?: { wrapper: QuoteWrapper, executeEffects: boolean }) {
    }
}


export class QuoteUpdateSuccess implements Action {
    public type: string = QuoteActionTypes.QUOTE_UPDATE_SUCCESS;

    constructor(public payload?: { wrapper: QuoteWrapper}) {
    }
}

export class ServiceLineUpdateAction implements Action {
    public type: string = QuoteActionTypes.QUOTE_LINE_UPDATE_ACTION;

    constructor(public payload?: { serviceLine: ServiceLine, executeEffects: boolean }) {
    }
}

export class ServiceLineUpdateSuccessAction implements Action {
    public type: string = QuoteActionTypes.QUOTE_LINE_UPDATE_SUCCESS;

    constructor(public payload: { serviceLine: ServiceLine, executeEffects: boolean }) {
    }
}

export class QuoteServiceAppliedPriceUpdateAction implements Action {
    public type: string = QuoteActionTypes.QUOTE_SERVICE_APPLIED_PRICE_UPDATE_ACTION;

    constructor(public payload?: { quoteService: QuoteService, appliedPrice: string }) {
    }
}

export class QuoteServiceUpdateSuccess implements Action {
    public type: string = QuoteActionTypes.QUOTE_SERVICE_UPDATE_SUCCESS;

    constructor(public payload?: { actionType: QuoteServiceUpdateAction, quoteService: QuoteService }) {
    }
}

export class PricingItemValidateAction implements Action {
    public type: string = QuoteActionTypes.PRICING_ITEM_VALIDATE_ACTION;

    constructor(public payload?: { codeService: string, pricingItem: PricingItem, salesType?: EnumQuoteServiceSalesType }) {
    }
}

export class PricingItemUpdateAction implements Action {
    public type: string = QuoteActionTypes.PRICING_ITEM_UPDATE_ACTION;

    constructor(public payload?: { codeService: string, pricingItem: PricingItem, salesType?: EnumQuoteServiceSalesType, executeEffects: boolean  }) {
    }
}


export class PricingItemDeleteAction implements Action {
    public type: string = QuoteActionTypes.PRICING_ITEM_DELETE_ACTION;

    constructor(public payload?: { codeService: string, pricingItem: PricingItem, salesType?: EnumQuoteServiceSalesType }) {
    }
}

export class ReferentialCreateAction implements Action {
    public type: string = QuoteActionTypes.CREATE_REFERENTIAL_ACTION;

    constructor(public payload?: { referential: any }) {
    }
}

export class ReferentialServicesCreateAction implements Action {
    public type: string = QuoteActionTypes.CREATE_REFERENTIAL_SERVICES_ACTION;

    constructor(public payload?: { referentialServices: any }) {
    }
}

export class HydrateQuote implements Action {
    public type: string = QuoteActionTypes.HYDRATE_QUOTE_STORE;
    constructor() {
    }
}
export class HydrateQuoteSuccess implements Action {
    public type: string = QuoteActionTypes.HYDRATE_QUOTE_STORE_SUCCESS;
    constructor(public payload?: QuoteState) {
    }
}

export type QuoteActions =
    HydrateQuoteSuccess|
    QuoteUpdateAction |
    QuoteServiceUpdateAction |
    PricingItemUpdateAction |
    QuoteServiceUpdateSuccess |
    QuoteServiceAppliedPriceUpdateAction |
    ReferentialCreateAction |
    ReferentialServicesCreateAction;
